import { getAuthUserType } from "utils/authStorage";

const ADMIN_ROLES = ["SUPER_ADMIN"];

export function getCurrentRole() {
  const role = getAuthUserType().toUpperCase();
  // login/admin issues SUPER_ADMIN JWT; DB user may still be ADMIN
  if (role === "ADMIN") return "SUPER_ADMIN";
  return role;
}

export function isAdminUser() {
  return ADMIN_ROLES.includes(getCurrentRole());
}

export function canAccessRoute(route) {
  if (route?.route === "/login") return true;
  if (!route?.key) return true;

  const role = getCurrentRole();
  if (!role) return route.route === "/login";

  if (route.roles && Array.isArray(route.roles)) {
    return route.roles.includes(role);
  }

  return true;
}

export function filterRoutesForRole(allRoutes) {
  return allRoutes.filter((route) => {
    if (!route.type) return true;
    return canAccessRoute(route);
  });
}

export function getDefaultHomePath() {
  return "/dashboard";
}
